module.exports = __webpack_public_path__ + "static/img/img_cabinet.38a616e2.png";